import { filter, set } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, TextField, Grid, Select, FormControl, InputLabel, MenuItem } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import PaymentCodeDialog from "src/components/dialogs/PaymentCodeDialog";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import TiejunPicker from "src/components/common/TiejunPicker";
import CityPicker from "src/components/CityPicker";
import ChangeMerchantPwdDialog from "./components/ChangeAdminPwdDialog";
import MerchantInfoDrawer from "src/components/common/MerchantInfoDrawer";
import MerchantEdit from "./components/MerchantEdit";
import Confirm from "src/components/common/ConfirmDialog";
import ChangeMerchantVersionDialog from "./components/ChangeMerchantVersionDialog";
import BindMerchantParentDialog from "./components/BindMerchantParentDialog";
import ChannelDetailDialogTwo from "./components/ChannelDetailDialogTwo";
import AgentPicker from "src/components/common/AgentPicker";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";

const TABLE_HEAD = [
  { id: "mid", label: "ID", alignRight: false, sortable: true },
  { id: "name", label: "商户名称", alignRight: false },
  { id: "type", label: "类型", alignRight: false },
  // { id: "version", label: "版本", alignRight: false },
  { id: "realname", label: "商户姓名", alignRight: false },
  { id: "mini", label: "小程序管理员", alignRight: false },
  { id: "rangli", label: "让利", alignRight: false, sortable: true },
  { id: "xfq", label: "消费券", alignRight: false, sortable: true },
  { id: "pointsGreen", label: "积分", alignRight: false, sortable: true },
  { id: "status", label: "是否启用", alignRight: false },
  { id: "isShow", label: "是否显示", alignRight: false },
  { id: "at", label: "支付通道", alignRight: false },
  { id: "parent", label: "推荐人", alignRight: false },
  { id: "agent", label: "区代", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false, sortable: true },
  { id: "操作" },
];

const moreMenus = [
  { title: "编辑", icon: iconEdit2 },
  { title: "收款码", icon: iconEdit2 },
  { title: "绑定超级管理员", icon: iconEdit2 },
  { title: "修改推荐人", icon: iconEdit2 },
  { title: "绑定区代", icon: iconEdit2 },
  // { title: "修改版本", icon: iconEdit2 },
  // { title: "配置三方商户", icon: iconEdit2 },
  { title: "开通三方支付", icon: iconEdit2 },
  { title: "开通业务", icon: iconEdit2 },
  { title: "微信实名认证", icon: iconEdit2 },
  { title: "支付宝实名认证", icon: iconEdit2 },
  { title: "重新入驻", icon: iconEdit2 },
  { title: "添加微信特约商户appid", icon: iconEdit2 },
  { title: "同步汇付商户信息", icon: iconEdit2 },
  // { title: "添加分账接收方", icon: iconEdit2 },
  // { title: "查看最大分账比例", icon: iconEdit2 },
  // { title: "重置密码", icon: iconEdit2 },
];

export default function MerchantList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [targetMerchant, setTargetMerchant] = useState({});

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [wxAuthData, setWxAuthData] = useState({});
  const [agentMap, setAgentMap] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    // search: "",
    sort: null,
    order: null,
    mid: "",
    name: "",
    provinceId: null,
    cityId: null,
    districtId: searchParams.get("districtId") || "",
    version: null,
    createdAt: null,
    platformCode:'qdkf'
  });

  const [form, setForm] = useState({
    userType: "0",
    userName: 0,
    phone: "",
    certId: "",
    cardNo: "",
    certIdExpires: "",
    bankCode: "",
    cardName: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  useEffect(() => {
    // getAgentMap();
  }, [items]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/merchant/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);

    if (targetMerchant.mid) {
      const item = data.find((d) => d.mid == targetMerchant.mid);

      if (item) {
        setTargetMerchant(item);
      }
    }
  }

  async function getAgentMap() {
    const { data, count } = await asyncRequest({
      path: "/agent/map",
      data: {
        agentIds: items.filter((it) => it.agentId).map((it) => it.agentId),
      },
    });

    setAgentMap(data);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleSizeChange(value) {
    setFilter({
      ...filter,
      size: value,
    });
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleRequestSort(value) {
    console.log(value);
    const order = filter.sort == value ? (filter.order == "asc" ? "desc" : "asc") : "asc";
    setFilter({
      ...filter,
      page: 0,
      sort: value,
      order,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/merchant/edit/${row.mid}`, { state: row });
      setTargetMerchant(row);
      setAction("editMerchant");
    } else if (type === "绑定超级管理员") {
      UserPicker({
        onSelect(v) {
          console.log(v);
          // handleEdit(row.id, { categoryId: v.id });
          handleBindMiniAdmin(row.mid, v);
        },
      });
    } else if (type === "修改推荐人") {
      // TiejunPicker({
      //   onSelect(v) {
      //     console.log(v);
      //     handleBindParent(row.mid, v);
      //   },
      // });
      setTargetMerchant(row);
      setAction("bindParent");
    } else if (type === "绑定区代") {
      AgentPicker({
        condition: {
          // districtId: row.districtId,
        },
        onSelect(v) {
          console.log(v);
          // handleEdit(row.id, { categoryId: v.id });
          handleBindAgent(row.mid, v);
        },
      });
    } else if (type === "收款码") {
      setTargetMerchant(row);
      setAction("payCode");
    } else if (type === "配置三方商户") {
      console.log(row, (row.idCardEndDate || "").replace(/\-/g, ""));
      setTargetMerchant(row);
      setForm({
        userType: "0",
        userName: row.realname,
        phone: row.mobile,
        certId: row.idCardNo,
        cardNo: row.accountNumber,
        certIdExpires: (row.idCardEndDate || "").replace(/\-/g, ""),
        bankCode: "",
        cardName: row.realname,
      });
      setAction("register");
      // handleRegister(row)
    } else if (type === "重置密码") {
      setTargetMerchant(row);
      setAction("changePwd");
    } else if (type === "添加分账接收方") {
      addReceiver(row.mid);
    } else if (type === "查看最大分账比例") {
      checkMaxFengzhangRatio(row.mid);
    } else if (type === "升级2.0") {
      if (row.version == 2) return alert("已经是2.0商户，无需升级");
      // setTargetMerchant(row);
      // setAction("upgrade");
      handleUpgrade(row);
    } else if (type === "修改版本") {
      setTargetMerchant(row);
      setAction("changeVersion");
    } else if (type == "开通三方支付") {
      applyHuifu(row.mid);
    } else if (type == "开通业务") {
      openHuifuBiz(row.mid);
    } else if (type == "微信实名认证") {
      authWxRealname(row.mid);
    } else if (type == "支付宝实名认证") {
      authAliRealname(row.mid);
    } else if (type == "添加微信特约商户appid") {
      addAppId(row.mid);
    } else if (type == "重新入驻") {
      Confirm({
        title: "确定重新入驻？",
        message: "不可逆，请谨慎操作",
        onConfirm() {
          applyHuifu(row.mid, true);
        },
      });
    } else if (type == "同步汇付商户信息") {
      syncHuifuInfo(row.mid);
    }
  };

  function handleUpgrade({ name, mid }) {
    Confirm({
      message: `确定将商户 "${name}" 升级到2.0版本吗？`,
      async onConfirm() {
        const { msg } = await asyncRequest({
          path: "/merchant/upgrade",
          data: { mid },
        });

        alert(msg, "success");
        getItems();
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleRegister() {
    const { msg } = await asyncRequest({
      path: "/merchant/channel/register",
      data: { mid: targetMerchant.mid, mer: form },
    });

    alert(msg, "success");
    getItems();
    setAction("");
  }

  // 开通微信支付
  async function applyHuifu(mid, reEnter = false) {
    try {
      // if (submitting) return;
      // setSubmitting(true);
      const { msg } = await asyncRequest({
        path: "/merchant/huifu/apply",
        data: {
          mid,
          reEnter,
        },
        complete() {
          // setSubmitting(false);
        },
      });

      alert(msg, "success");
      getItems();
    } catch (error) {
      console.log("error", error);
      setSubmitting(false);
    }
  }

  // 开通业务
  async function openHuifuBiz(mid) {
    try {
      if (submitting) return;
      setSubmitting(true);
      const { msg } = await asyncRequest({
        path: "/merchant/huifu/openBiz",
        data: { mid },
        complete() {
          setSubmitting(false);
        },
      });

      alert(msg, "success");
    } catch (error) {
      console.log("error", error);
      setSubmitting(false);
    }
  }

  // reapply
  async function authWxRealname(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/huifu/authWxRealname",
      data: { mid },
    });

    alert(msg, "success");
    getItems();
  }

  async function authAliRealname(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/huifu/authAliRealname",
      data: { mid },
    });

    alert(msg, "success");
    getItems();
  }

  // 手动实名认证
  async function handleConfirmWxAuth(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/huifu/confirmWxAuth",
      data: { mid },
    });

    alert(msg, "success");
    getItems();
  }

  async function handleConfirmAliAuth(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/huifu/confirmAliAuth",
      data: { mid },
    });

    alert(msg, "success");
    getItems();
  }

  async function syncHuifuInfo(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/huifu/sync",
      data: { mid },
    });

    alert(msg, "success");
    getItems();
  }

  async function addAppId(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/huifu/addAppId",
      data: { mid },
    });

    alert(msg, "success");
  }

  async function handleBindMiniAdmin(mid, user) {
    const { msg } = await asyncRequest({
      path: "/merchant/bindAdmin",
      data: { mid, uid: user.uid },
    });

    alert(msg, "success");
    getItems();
  }

  async function handleBindParent(mid, user) {
    const { msg } = await asyncRequest({
      path: "/merchant/bindParent",
      data: { mid, uid: user.uid },
    });

    alert(msg, "success");
    getItems();
  }

  async function handleBindAgent(mid, agent) {
    const { msg } = await asyncRequest({
      path: "/merchant/bindAgent",
      data: { mid, agentId: agent.id },
    });

    alert(msg, "success");
    getItems();
  }

  async function addReceiver(mid) {
    const { msg } = await asyncRequest({
      path: "/merchant/addReceiver",
      data: { mid },
    });

    alert(msg, "success");
  }

  async function checkMaxFengzhangRatio(mid) {
    const { msg, data } = await asyncRequest({
      path: "/merchant/checkMaxFenzhangRatio",
      data: { mid },
    });

    alert(data, "success");
  }

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  async function toggleShow(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/toggleShow",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isShow = !item.isShow;
    setItems([...items]);
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
      page: 0,
    });
  }

  async function handleExport() {
    const { msg } = await asyncRequest({
      path: "/merchant/export",
      data: filter,
    });

    alert(msg, "success");
  }

  function renderChannel(row) {
    const { application, mid } = row;
    let text = "";
    if (!application) {
      text = "点击入驻";
    } else {
      if (application.applyStatus != "Y") {
        text = "待入驻审核";
      } else {
        if (!application.agreementApplyStatus) {
          text = "待开通业务";
        } else if (application.agreementApplyStatus != "Y") {
          text = "待签约";
        }
      }
    }

    if (text) {
      return (
        <Typography
          fontSize={14}
          sx={{ cursor: "pointer" }}
          onClick={() => {
            // if (text == "待开通业务") {
            //   openHuifuBiz(mid);
            //   return;
            // }
            setTargetMerchant(row);
            setAction("channel");
            // applyHuifu(mid);
          }}
        >
          {text}
        </Typography>
      );
    }

    return (
      <Stack
        onClick={() => {
          setTargetMerchant(row);
          setAction("channel");
        }}
      >
        <Typography fontSize={14} sx={{ cursor: "pointer" }}>
          微信: {application.wxApplyStatus == "APPLYMENT_STATE_PASSED" || application.wxApplyStatus == "APPLYMENT_STATE_FREEZED" ? "已认证" : "未认证"}
        </Typography>
        <Typography fontSize={14} sx={{ cursor: "pointer" }}>
          支付宝: {application.aliApplyStatus == "AUDIT_PASS" ? "已认证" : "未认证"}
        </Typography>
      </Stack>
    );
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="商户列表">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              商户列表
            </Typography>

            <Button
              variant="contained"
              // component={RouterLink} to="/merchant/add"
              onClick={() => {
                setTargetMerchant({});
                setAction("addMerchant");
              }}
              startIcon={<Icon icon={plusFill} />}
            >
              添加商户
            </Button>
          </Stack>

          <Card>
            <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} onExport={handleExport}>
              <Grid container>
                <Grid item md={3}>
                  <CityPicker
                    code={filter.districtId}
                    onSelect={(val) => {
                      console.log(val);
                      setFilter({
                        ...filter,
                        districtId: val.district ? val.district.id : null,
                        page: 0,
                      });
                    }}
                  />
                </Grid>

                <Grid item md={3}>
                  <MyDateRangePicker
                    value={filter.createdAt}
                    onChange={(val) => {
                      setFilter({
                        ...filter,
                        createdAt: val,
                      });
                    }}
                  />
                </Grid>

                <Grid item md={3}>
                  <TextField
                    size="small"
                    label="商户名称"
                    placeholder="商户名称"
                    autoComplete="off"
                    id="name"
                    value={filter.name}
                    onChange={(e) => {
                      handleFilterChange("name", e.target.value);
                    }}
                  />
                </Grid>

                <Grid item md={3}>
                  <TextField
                    size="small"
                    label="汇付商户号"
                    placeholder="汇付商户号"
                    autoComplete="off"
                    id="hfUid"
                    value={filter.hfUid}
                    onChange={(e) => {
                      handleFilterChange("hfUid", e.target.value);
                    }}
                  />
                </Grid>

                <Grid item md={3}>
                  <TextField
                    // style={{ width: 200 }}
                    label="商户ID"
                    size="small"
                    placeholder="商户ID"
                    autoComplete="off"
                    id="mid"
                    value={filter.mid}
                    onChange={(e) => {
                      handleFilterChange("mid", e.target.value);
                    }}
                  />
                </Grid>

                {/* <FormControl size="small">
                  <InputLabel id="version">版本</InputLabel>
                  <Select
                    // labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    label="版本"
                    value={filter.version}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        version: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[null, 1, 2, 3].map((version, idx) => (
                      <MenuItem key={idx} value={version} name={version}>
                        {idx == 0 ? "全部" : ["全部", "1.0", "2.0", "3.0"][version]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
              </Grid>
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table stickyHeader>
                  <ListHead headLabel={TABLE_HEAD} onRequestSort={handleRequestSort} orderBy={filter.sort} order={filter.order} />
                  <TableBody>
                    {items.map((row) => {
                      const { mid, name, type, parent, xfq, pointsGreen, rangli, realname, createdAt, status, agentId, isShow, uid } = row;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={mid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, id)}
                            />
                          </TableCell> */}
                          <TableCell align="left">{mid}</TableCell>
                          <TableCell align="left" sx={{ minWidth: 150 }}>
                            {name}
                          </TableCell>
                          <TableCell align="left">{["个体户", "企业", "小微"][type]}</TableCell>
                          {/* <TableCell align="left">{version}.0</TableCell> */}
                          <TableCell align="left" sx={{ minWidth: 80 }}>
                            {realname}
                          </TableCell>
                          {/* <TableCell align="left">{admin && admin.user ? <UserInfo {...admin.user} enablePreview /> : null}</TableCell> */}
                          <TableCell align="left">{uid}</TableCell>
                          <TableCell align="left">{rangli}%</TableCell>

                          <TableCell align="left">{xfq}</TableCell>
                          <TableCell align="left">{pointsGreen}</TableCell>
                          {/* <TableCell align="left">{pointsGained}</TableCell> */}
                          {/* <TableCell align="left">{isZhiyin ? "是" : "否"}</TableCell> */}
                          <TableCell align="left">
                            <Switch checked={status === 1} onChange={() => toggleEnabled(mid)} />
                          </TableCell>
                          <TableCell align="left">
                            <Switch checked={isShow} onChange={() => toggleShow(mid)} />
                          </TableCell>
                          <TableCell align="left" style={{ whiteSpace: "nowrap" }}>
                            {renderChannel(row)}
                          </TableCell>
                          <TableCell align="left">{parent ? <UserInfo {...parent} enablePreview /> : null}</TableCell>
                          <TableCell align="left">{agentId ? <UserInfo {...(agentMap[agentId]?.user || {})} enablePreview /> : null}</TableCell>
                          <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                          <TableCell align="right">
                            <Stack direction="row">
                              <Button
                                variant="text"
                                onClick={() => {
                                  setTargetMerchant(row);
                                  setAction("viewDetail");
                                }}
                              >
                                详情
                              </Button>
                              <MoreMenu spread={false} menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} onSizeChange={handleSizeChange} />
          </Card>
        </Container>

        {action === "payCode" && (
          <PaymentCodeDialog
            open={true}
            merchant={targetMerchant}
            onClose={() => {
              setAction("");
              setTargetMerchant({});
            }}
          />
        )}

        {action === "register" && (
          <FormDialog title={action === "add" ? "配置第三方商户" : "配置第三方商户"} open={!!action} onClose={() => setAction()} onConfirm={handleRegister}>
            <FormItem title="法人姓名" required>
              <TextField fullWidth placeholder="请输入法人姓名" autoComplete="off" id="userName" value={form.userName} size="small" onChange={(e) => handleIptChange("userName", e.target.value)} />
            </FormItem>
            <FormItem title="法人手机号" required>
              <TextField fullWidth placeholder="请输入法人手机号" type="number" autoComplete="off" id="phone" value={form.phone} size="small" onChange={(e) => handleIptChange("phone", e.target.value)} />
            </FormItem>
            <FormItem title="身份证" required>
              <TextField fullWidth placeholder="请输入身份证" autoComplete="off" id="certId" value={form.certId} size="small" onChange={(e) => handleIptChange("certId", e.target.value)} />
            </FormItem>
            <FormItem title="身份证有效期" required>
              <TextField fullWidth placeholder="请输入身份证有效期" type="number" autoComplete="off" id="certIdExpires" value={form.certIdExpires} size="small" onChange={(e) => handleIptChange("certIdExpires", e.target.value)} />
            </FormItem>

            <FormItem title="银行卡姓名" required>
              <TextField fullWidth placeholder="银行卡姓名" autoComplete="off" id="cardName" value={form.cardName} size="small" onChange={(e) => handleIptChange("cardName", e.target.value)} />
            </FormItem>
            <FormItem title="银行卡卡号" required>
              <TextField fullWidth placeholder="银行卡卡号" type="number" autoComplete="off" id="cardNo" value={form.cardNo} size="small" onChange={(e) => handleIptChange("cardNo", e.target.value)} />
            </FormItem>
          </FormDialog>
        )}
      </Page>

      {action == "changePwd" && <ChangeMerchantPwdDialog open merchant={targetMerchant} onClose={() => setAction("")} />}
      {action == "viewDetail" && <MerchantInfoDrawer open mid={targetMerchant.mid} logo={targetMerchant.logo} name={targetMerchant.name} onClose={() => setAction("")} />}
      {(action == "editMerchant" || action == "addMerchant") && (
        <MerchantEdit
          open
          item={targetMerchant}
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}
      {action == "changeVersion" && (
        <ChangeMerchantVersionDialog
          open
          merchant={targetMerchant}
          onFinish={() => {
            getItems();
            setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}

      {action == "channel" && (
        <ChannelDetailDialogTwo
          open
          merchant={targetMerchant}
          onAuthWx={(mid) => {
            authWxRealname(mid);
          }}
          onAuthAli={(mid) => {
            authAliRealname(mid);
          }}
          onConfirmWxAuth={(mid) => {
            handleConfirmWxAuth(mid);
          }}
          onConfirmAliAuth={(mid) => {
            handleConfirmAliAuth(mid);
          }}
          onFinish={() => {
            getItems();
            // setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}

      {action == "bindParent" && (
        <BindMerchantParentDialog
          open
          merchant={targetMerchant}
          onFinish={() => {
            getItems();
            setAction("");
          }}
          onClose={() => setAction("")}
        />
      )}
    </>
  );
}
